import Navbar from './components/Navbar';
import Hero, { Ticker } from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollGauge from './components/ScrollGauge';
import useReveal from './components/useReveal';

export default function App() {
  useReveal();

  return (
    <>
      <ScrollGauge />
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <About />
        <Products />
        <Features />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
